module.exports = __webpack_public_path__ + "img/done-fill.29444db6.svg";